export default __webpack_public_path__ + "static/media/logo-ivtgrade.1a7db776.svg";